import get from 'lodash/get';
import { ReactElement } from 'react';
import { FunctionField, UrlFieldProps, useRecordContext } from 'react-admin';

export default function SecureUrlField(props: UrlFieldProps): ReactElement {
  const record = useRecordContext(props);
  const { source, label } = props;
  const raw = get(record, source) ?? '';
  if (!raw) {
    return <FunctionField label={label} render={() => <i>Unknown</i>} />;
  }

  const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
  return (
    <FunctionField
      label={label}
      render={() => (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {raw}
        </a>
      )}
    />
  );
}
